import { jsx as _jsx } from "react/jsx-runtime";
import { media } from "sprout-ui-theme";
import { PageToolbar as BasePageToolbar } from "@sprout/client-components/dist/PageToolbar";
import styled from "styled-components";
const PageToolbar = styled(BasePageToolbar)`
  margin-top: auto;

  ${media.down("medium")} {
    bottom: 104px;
  }

  ${media.target("touch")} {
    bottom: 104px;
  }
`;
const PostPageToolbar = (props)=>{
    const { children  } = props;
    return /*#__PURE__*/ _jsx(PageToolbar, {
        children: children
    });
};
export default PostPageToolbar;
